import { format } from 'date-fns'

/**
 * Parse a date string (YYYY-MM-DD or ISO) into a local Date, avoiding
 * the UTC-midnight shift that causes off-by-one errors in western timezones.
 */
const parseLocalDate = (dateString: string): Date => {
  const [y, m, d] = dateString.split('T')[0].split('-').map(Number)
  return new Date(y, m - 1, d)
}

/**
 * Format a date string for display (e.g., "Jan 15, 2025")
 */
export const formatPilotDate = (dateString: string): string => {
  return parseLocalDate(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/**
 * Format a date string for display using a specific locale
 */
export const formatPilotDateLocale = (dateString: string, locale?: string): string => {
  return parseLocalDate(dateString).toLocaleDateString(locale)
}

/**
 * Extract YYYY-MM-DD from an ISO date string for date input fields
 */
export const formatDateForInput = (isoDate: string): string => {
  return isoDate.split('T')[0]
}

/**
 * Get minimum selectable date (at least 24 hours in the future)
 */
export const getMinPilotEndDate = (): string => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 2) // At least 24 hours in the future - the BE also enforces this
  return format(tomorrow, 'yyyy-MM-dd')
}

/**
 * Get default pilot end date (4 weeks from today)
 */
export const getDefaultPilotEndDate = (): string => {
  const fourWeeks = new Date()
  fourWeeks.setDate(fourWeeks.getDate() + 28)
  return format(fourWeeks, 'yyyy-MM-dd')
}
